import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Sort from '../Filters/Sort';
import ViewMode from '../Filters/ViewMode';

const ShareViewActions = ({
  share,
  setOrder,
  filesParams,
  setFilesView,
}) => {
  let {
    order,
    orderby,
    view,
  } = filesParams;

  if (share?.order) {
    orderby = share.order[0];
    order = share.order[1];
  }
  if (share?.view) {
    ({ view } = share);
  }

  return (
    <div className="share-list-header-actions">
      <Sort
        order={order}
        orderby={orderby}
        setOrder={setOrder}
        collection={share.top_collection}
        sort={share.order}
      />
      <ViewMode
        view={view || 'grid'}
        setView={setFilesView}
        allowedViews={['grid', 'framed', 'masonry', 'tile', 'slider']}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  filesParams: state.Files.params,
  profile: state.Auth.profile,
});

ShareViewActions.propTypes = {
  share: PropTypes.object.isRequired,
  setOrder: PropTypes.func,
  filesParams: PropTypes.object.isRequired,
  setFilesView: PropTypes.func.isRequired,
};

ShareViewActions.defaultProps = {
  setOrder: () => { },
};

export default connect(mapStateToProps)(ShareViewActions);
